// 사내물류 코드(sol_cd = 2000)를 가져오는 Mixin
let LogisticsCodeDtlMixin = {
    data () {

        const logisticsCd = this.$store.state.codeRequestStore.search.combobox.logisticsCd.data

        let receiveStatusList = [], receiveStatusListForSave = [], sendStatusList = [], sendStatusList2 = [{cdId: '', cdNm: '전체'}]
        let receiveScnList = [], sendScnList = [{cdId: '', cdNm: '전체'}]
        let receiveShpcScnList = [], sendShpcScnList = [], sendShpcScnListExpr = []
        let receiveEtcScnList = [], receiveAreaScnList = []
        let terrorSignScnList = [], terrorSignScnListForReturn = []
        let sendContentsScnList = [], ppsScnList = []
        let deliveryScnList = []
        let receivePurposeList= []
        let kioskUseScnList = []
        let noticeTypeList = []
        let userStatusList = [{cdId: '', cdNm: '전체'}]

        let ampmScnListForList = [{cdId: '', cdNm: '전체'}], ampmScnList = []
        let pouchStatusList = [], pouchContentsScnList = []

        for (let item of logisticsCd) {
            if (item.cdGrup === '12') {
                // 특송사 (수령)
                receiveShpcScnList.push(item)
            } else if (item.cdGrup === '13') {
                // 특송사 (발송)
                if (item.cdId !== '04' && item.cdId !== '05') {
                    sendShpcScnListExpr.push(item)
                }
                sendShpcScnList.push(item)
            } else if (item.cdGrup === '14') {
                // 진행 상태 (수령)
                if (item.cdId === '01' || item.cdId === '97' || item.cdId === '98') {
                    receiveStatusListForSave.push(item)
                }
                receiveStatusList.push(item)
            } else if (item.cdGrup === '15') {
                // 진행 상태 (발송)
                sendStatusList2.push(item)
                if(item.cdId !== '98'){
                    sendStatusList.push(item)
                }
            } else if (item.cdGrup === '16') {
                // 취급 구분 (수령)
                receiveScnList.push(item)
            } else if (item.cdGrup === '17') {
                // 취급 구분 (발송)
                sendScnList.push(item)
            } else if (item.cdGrup === '18') {
                // 구분 (수령)
                receiveEtcScnList.push(item)
            } else if (item.cdGrup === '19') {
                // 수신 회사
                receiveAreaScnList.push(item)
            } else if (item.cdGrup === '21') {
                // 내용물 (발송)
                sendContentsScnList.push(item)
            } else if (item.cdGrup === '22') {
                // 용도 (발송)
                ppsScnList.push(item)
            } else if (item.cdGrup === '29') {
                // 상태
                pouchStatusList.push(item)
            } else if (item.cdGrup === '30') {
                // 시간
                ampmScnListForList.push(item)
                ampmScnList.push(item)
            } else if (item.cdGrup === '33') {
                // 상태 여부
                terrorSignScnList.push(item)
                if (item.cdId === '02' || item.cdId === '03' || item.cdId === '04') {
                    terrorSignScnListForReturn.push(item)
                }
            } else if (item.cdGrup === '34') {
                // 발송 수단
                deliveryScnList.push(item)
            } else if (item.cdGrup === '36') {
                // 반입 목적
                receivePurposeList.push(item)
            } else if (item.cdGrup === '38') {
                // 내용
                pouchContentsScnList.push(item)
            } else if (item.cdGrup === '31'){
                kioskUseScnList.push(item)
            } else if(item.cdGrup === '39'){
                noticeTypeList.push(item)
            } else if(item.cdGrup === '46'){
                userStatusList.push(item)
            }
        }

        if(userStatusList.length >= 4) { // 활성화, 휴먼 계정, 탈퇴 순으로 나열하기 위함.
            [userStatusList[1], userStatusList[2], userStatusList[3]] = [userStatusList[3], userStatusList[1], userStatusList[2]]
        }

        // 취급 구분 (수령) receiveScnList 정렬 순서
        let receiveScnListOrder = ['09', '01', '02', '03', '04', '05', '06', '07', '08'];
        // 취급 구분 (수령) 정렬된 배열 생성
        receiveScnList.sort((a, b) => {
            let aIndex = receiveScnListOrder.indexOf(a.cdId);
            let bIndex = receiveScnListOrder.indexOf(b.cdId);
            return aIndex - bIndex;
        });

        return {
            noticeTypeList : noticeTypeList,
            kioskUseScnList : kioskUseScnList,
            receiveShpcScnList: receiveShpcScnList,
            sendShpcScnList: sendShpcScnList,
            sendShpcScnListExpr: sendShpcScnListExpr,

            receiveStatusList: receiveStatusList,
            receiveStatusListForSave: receiveStatusListForSave,
            sendStatusList: sendStatusList,
            sendStatusList2: sendStatusList2,
            receiveScnList: receiveScnList,
            sendScnList: sendScnList,
            receiveEtcScnList: receiveEtcScnList,
            receiveAreaScnList: receiveAreaScnList,
            terrorSignScnList: terrorSignScnList,
            terrorSignScnListForReturn: terrorSignScnListForReturn,

            sendContentsScnList: sendContentsScnList,
            ppsScnList: ppsScnList,
            deliveryScnList: deliveryScnList,
            receivePurposeList: receivePurposeList,

            pouchStatusList: pouchStatusList,
            ampmScnListForList: ampmScnListForList,
            ampmScnList: ampmScnList,
            pouchContentsScnList: pouchContentsScnList,

            userStatusList : userStatusList,

        }
    }
}

// 사내물류 (물품, 파우치)의 사업장을 가져오는 Mixin
let ZoneMixin = {
    methods: {
        // 1depth 값에 따라, 2depth 값을 세팅한다.
        onChange1Depth (refNm) {
          const vm = this
          const refs = vm.$refs

          const zone1Depth = refs[`${refNm}`].kendoWidget().value()
          vm.zone2DepthListForAll = !!vm.zone2DepthMapForAll.get(zone1Depth) ? vm.zone2DepthMapForAll.get(zone1Depth) : []
          vm.zone2DepthList = !!vm.zone2DepthMap.get(zone1Depth) ? vm.zone2DepthMap.get(zone1Depth) : []
          vm.zone2DepthListForPouch = !!vm.zone2DepthMapForPouch.get(zone1Depth) ? vm.zone2DepthMapForPouch.get(zone1Depth) : []
        },

        // 2depth 값에 따라, 3depth 값을 세팅한다.
        onChange2Depth (refNm) {
          const vm = this
          const refs = vm.$refs

          const zone2Depth = refs[`${refNm}`].kendoWidget().value()
          vm.zone3DepthList = vm.zone3DepthMap.get(zone2Depth)
        },

        onChange3Depth (refNm) {
            const vm = this
            const refs = vm.$refs

            const zone3Depth = refs[`${refNm}`].kendoWidget().value()
            vm.zone4DepthList = vm.zone4DepthMap.get(zone3Depth)
        },

        onChange4Depth(refNm){
            const vm = this
            const refs = vm.$refs

            const zone4Depth = refs[`${refNm}`].kendoWidget().value()
            vm.zone5DepthList = vm.zone5DepthMap.get(zone4Depth)
        },
    },
    data () {
        const loginUserData = JSON.parse(sessionStorage.getItem("loginUserData"))
        const zoneNmList = this.$store.state.codeRequestStore.search.combobox.zoneNmList.data

        let zone1DepthListForAll = [], zone1DepthList = [], zone1DepthListForPouch = [],
            zone2DepthMapForAll = new Map(), zone2DepthMap = new Map(), zone2DepthMapForPouch = new Map(),
            zone3DepthMap = new Map() ,zone4DepthMap = new Map() ,zone5DepthMap = new Map()

        for (let item of zoneNmList) {
            if (item.zoneLevel === '1') {
                /* 키오스크 + 파우치 */
                zone1DepthListForAll.push({
                    cdId: item.zoneId,
                    cdNm: item.zoneNm
                })
                /* 파우치 */
                if (item.pouchUseYn === 'Y') {
                    zone1DepthListForPouch.push({
                        cdId: item.zoneId,
                        cdNm: item.zoneNm
                    })
                }
                /* 키오스크 */
                if (item.sendRecvUseYn === 'Y') {
                    zone1DepthList.push({
                        cdId: item.zoneId,
                        cdNm: item.zoneNm
                    })
                }
            } else if (item.zoneLevel === '2') {
                /* 키오스크 + 파우치 */
                let zone2DepthListForAll = zone2DepthMapForAll.get(item.zoneParent)
                if (zone2DepthListForAll === undefined) {
                    zone2DepthListForAll = []
                }
                zone2DepthListForAll.push({
                    cdId: item.zoneId,
                    cdNm: item.zoneNm
                })
                zone2DepthMapForAll.set(item.zoneParent, zone2DepthListForAll)
                /* 파우치 */
                let zone2DepthListForPouch = zone2DepthMapForPouch.get(item.zoneParent)
                if (zone2DepthListForPouch === undefined) {
                    zone2DepthListForPouch = []
                }
                if (item.pouchUseYn === 'Y'){
                    zone2DepthListForPouch.push({
                        cdId: item.zoneId,
                        cdNm: item.zoneNm
                    })
                    zone2DepthMapForPouch.set(item.zoneParent, zone2DepthListForPouch)
                }
                /* 키오스크 */
                let zone2DepthList = zone2DepthMap.get(item.zoneParent)
                if (zone2DepthList === undefined) {
                    zone2DepthList = []
                }
                if(item.sendRecvUseYn === 'Y'){
                    zone2DepthList.push({
                        cdId: item.zoneId,
                        cdNm: item.zoneNm
                    })
                    zone2DepthMap.set(item.zoneParent, zone2DepthList)
                }
            } else if (item.zoneLevel === '3') {
                /* 키오스크 + 파우치 */
                let zone3DepthList = zone3DepthMap.get(item.zoneParent)
                if (zone3DepthList === undefined) {
                    zone3DepthList = []
                }
                zone3DepthList.push({
                    cdId: item.zoneId,
                    cdNm: item.zoneNm
                })
                zone3DepthMap.set(item.zoneParent, zone3DepthList)
            } else if (item.zoneLevel === '4') {
                /* 키오스크 + 파우치 */
                let zone4DeptList = zone4DepthMap.get(item.zoneParent)
                // let zone4DepthListForReceive = zone4DepthMap.get(item.zoneId.slice(4))  // 거점값 통해 건물 데이터 가져오기 위함.
                if (zone4DeptList === undefined) {
                    zone4DeptList = []
                }
                zone4DeptList.push({
                    cdId: item.zoneId,
                    cdNm: item.zoneNm
                })
                zone4DepthMap.set(item.zoneParent, zone4DeptList)
            } else if(item.zoneLevel === '5'){
                /* 키오스크 + 파우치 */
                let zone5DepthList = zone5DepthMap.get(item.zoneParent)
                if (zone5DepthList === undefined){
                    zone5DepthList = []
                }
                zone5DepthList.push({
                    cdId: item.zoneId,
                    cdNm: item.zoneNm
                })
                zone5DepthMap.set(item.zoneParent, zone5DepthList)
            }
        }

        /**
         * 지사 -> 사업장 (1DEPTH)
         * 거점 -> 사업장 (2DEPTH)
         * 코스 -> 사업장 (3DEPTH)
         * 빌딩 -> 사업장 (4DEPTH)
         * 층 -> 사업장 (5DEPTH)
         **/

        return {
            zone1DepthListForAll: zone1DepthListForAll,
            zone1DepthList: zone1DepthList,
            zone1DepthListForPouch: zone1DepthListForPouch,
            zone2DepthList: [],
            zone3DepthList: [],
            zone4DepthList: [],
            zone5DepthList: [],
            zone2DepthMapForAll: zone2DepthMapForAll,
            zone2DepthMap: zone2DepthMap,
            zone2DepthMapForPouch: zone2DepthMapForPouch,
            zone3DepthMap: zone3DepthMap,
            zone4DepthMap: zone4DepthMap,
            zone5DepthMap: zone5DepthMap,
        }
    }
}

export {
    LogisticsCodeDtlMixin, ZoneMixin
}
